import { render, staticRenderFns } from "./UsersGroupsListItem.vue?vue&type=template&id=41a9f14a&"
import script from "./UsersGroupsListItem.vue?vue&type=script&lang=js&"
export * from "./UsersGroupsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports